module.exports = __webpack_public_path__ + "img/fav-white.f7db5a24.png";